import React, {useContext, useEffect, useRef, useState} from "react";
import {ThemeContext} from "../../../../../providers/themeContext/theme-context.tsx";
import CustomPopup from "../../../../../components/CustomPopup";
import {IUgcGameResponse} from "../../../../../common/utils/http/IResponse.ts";
import '../index.css'
import {formatTime} from "../../../../../common/utils/date-format.ts";
import {decimalToPercentage1} from "../../../../../common/utils/num-format.ts";
import {apiService} from "../../../../../common/utils/http/api-service.ts";
import {isEmptyOrNullOrUndefined} from "../../../../../common/utils/Datautil.ts";
import {ToastContext} from "../../../../../components/CustomToast/ToastProvider.tsx";
import useLoading from "../../../../../providers/loadingContext/useLoading.ts";
import debounce from "lodash/debounce";
import {GAEvents} from "../../../../../common/utils/GA4/GAEvents.ts";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    result: IUgcGameResponse | null;
    handlePlayAgain: () => void;
    openHintDialog: () => void;
};

// daily 游戏失败时的弹窗
const UGCGameEndDialog: React.FC<Props> = ({
                                               isOpen,
                                               onClose,
                                               result,
                                               handlePlayAgain,
                                               openHintDialog
                                           }) => {

    // 主题全局管理器
    const {imgUrls} = useContext(ThemeContext);
    // 提示toast
    const {addToast} = useContext(ToastContext);
    // 加载中弹窗
    const {showLoading, hideLoading} = useLoading();
    const targetRef = useRef(null)
    // 自己的点赞数
    const [myLikeCount, setMyLikeCount] = useState<number>(0);

    useEffect(() => {
        if (!isOpen) {
            setMyLikeCount(0)
            // GA埋点
            GAEvents.wordMakerResultShow()
        }
    }, [isOpen]);


    // 用户点击点赞
    const onLikeClick = debounce(async () => {
        if (isEmptyOrNullOrUndefined(result?.wordId)) return;
        if (myLikeCount) return;
        // GA埋点
        GAEvents.wordMakerResultLikeClick();

        try {
            showLoading()
            const response = await apiService.setUgcWordLike(result?.ugcGameLogId ?? '', result?.wordId ?? "", true)
            if (response.code === 200) {
                setMyLikeCount(1)
            } else {
                addToast({
                    type: 'error',
                    message: response.message
                })
            }
        } finally {
            hideLoading()

        }
    }, 100);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div
                ref={targetRef} className={`bg-color-white width-300 height-379 border-radius-10 display-fixed-center`}>
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl}
                     alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*关闭按钮*/}
                <img className="exit-close-btn" onClick={onClose}
                     src={imgUrls.closerBtnGreyUrl} alt="pic"/>
                {/*标题*/}
                <div
                    className="my-roboto-bold margin-top-20 font-size-16 text-center">
                    {result?.hasWin ? 'You Solved It!' : 'Oops, better luck next time…'}
                </div>
                {/*数据bar*/}
                <div
                    className={`margin-top-16 border-radius-6 bg-color-grey height-68 width-273 grid-3-columns margin-left-right-auto`}>
                    <div
                        className="display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div className="my-roboto-bold font-size-18">{result?.guessCount ?? 1}</div>
                        <div
                            className="font-size-10 my-roboto-light color-grey margin-top-2">Attempts
                        </div>
                    </div>
                    <div
                        className="display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div
                            className="my-roboto-bold font-size-18">{formatTime(result?.playTime ?? 1700)}</div>
                        <div
                            className="font-size-10 my-roboto-light color-grey margin-top-2">
                            Time used:
                        </div>
                    </div>
                    <div
                        className="display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div
                            className="my-roboto-bold font-size-18">{decimalToPercentage1(result?.solveRage ?? 1)}</div>
                        <div
                            className="font-size-10 my-roboto-light color-grey margin-top-2">Solve Rate
                        </div>
                    </div>
                </div>
                {/*单词卡片*/}
                <div
                    className="margin-top-7 height-180 width-273 position-relative margin-left-right-auto display-flex-row">
                    {/*单词卡片背景图*/}
                    <img className="height-180 width-273 z-index-minus-1 position-absolute"
                         src={imgUrls.aiChallengeDialogCardBgUrl} alt="pic"/>

                    <div
                        className="width-240  display-flex-column height-142 margin-left-right-auto margin-top-bottom-auto">
                        {/*头像部分*/}
                        <div
                            className="height-26 display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                            <img className="height-26 width-26 global-avatar-border-white border-radius-round"
                                 src={result?.userCgtnAvatar ?? imgUrls.defaultAvatarUrl} alt="pic"/>
                            <div
                                className="margin-left-4 font-size-13 my-roboto-medium">{result?.userCgtnName ?? result?.userGuestName}</div>
                        </div>
                        {/*字母卡片*/}
                        <div className="grid-5-columns grid-gap-3 width-180 margin-top-13 margin-left-right-auto">
                            {result?.correctWord.toUpperCase().split("").map((letter, index) => {
                                return (
                                    <div key={letter + index}
                                         className={`${result?.hasWin ? 'bg-color-liner-white-green' : 'bg-grey-custom'} display-flex-column display-flex-align-items-center display-flex-justify-content-center border-radius-4 width-33 height-40 `}>
                                        <div
                                            className="font-size-27 color-white my-roboto-bold ">{letter}</div>
                                    </div>
                                );
                            })}
                        </div>
                        {/*hint部分*/}
                        <div onClick={openHintDialog}
                             className=" margin-left-right-auto position-relative margin-top-14 width-233 border-radius-5 display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                            <div
                                className="font-size-13 height-16 margin-left-6 my-roboto-regular ellipsis color-black-custom width-226 text-center">
                                {result?.hintText}
                            </div>
                        </div>
                        {/*点赞和游玩数部分*/}
                        <div
                            className="margin-top-14 height-18 width-240 margin-left-right-auto display-flex-row display-flex-space-between">
                            <div
                                className="margin-left-40 display-flex-row display-flex-align-items-center">
                                <img className="width-18 height-18"
                                     src={(result?.playCount ?? 0) > 0 ? imgUrls.ugcPlaysBlueIcon : imgUrls.ugcPlaysGreyIcon}
                                     alt="pic"/>
                                <div
                                    className="margin-left-4 font-size-14 my-roboto-regular color-grey">{result?.playCount}
                                </div>
                            </div>
                            <div
                                className="margin-right-40 display-flex-row display-flex-align-items-center">
                                <img className="width-18 height-18"
                                     src={((result?.likes ?? 0) + myLikeCount) > 0 ? imgUrls.ugcLikesBlueIcon : imgUrls.ugcLikesGreyIcon}
                                     alt="pic"/>
                                <div
                                    className="margin-left-4 font-size-14 my-roboto-regular color-grey">{(result?.likes ?? 0) + myLikeCount}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*底部按钮*/}
                <div
                    className="width-273 display-flex-row margin-top-14 display-flex-space-between margin-left-right-auto">
                    <div onClick={onLikeClick}
                         className="width-104 height-43 border-radius-5 display-flex-row bg-btn-light-blue display-flex-align-items-center display-flex-justify-content-center">
                        <img className="height-21 width-21"
                             src={myLikeCount > 0 ? imgUrls.ugcPlaysBlueFillIcon : imgUrls.ugcPlaysBlueUnFillIcon}
                             alt="pic"/>
                        <div className="margin-left-6 color-blue-dark my-roboto-medium font-size-16">Like</div>
                    </div>
                    <div onClick={handlePlayAgain}
                         className="my-roboto-medium color-white width-164 height-43 border-radius-5 bg-color-blue-btn display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                        Continue
                    </div>
                </div>
            </div>
        </CustomPopup>
    );
}
export default UGCGameEndDialog;